<template>
  <TsCard appendClass="shadow-none h-full w-full" :data-testid="props.dataTestid">
    <TsImage class="flex mx-auto mb-2" :src="props.image" :alt="props.alt" :data-testid="props.image + '-img'" width="64" height="64" loading="lazy"/>
    <TsTypography align="center" append-class="mb-2" :as="isMobile ? 'h2' : 'h3'" weight="semibold" :data-testid="props.title + '-title'">{{ props.title }}</TsTypography>
    <TsTypography as='ul' appendClass='mb-0'>
      <TsTypography appendClass="mb-1" v-for="item in props.list" :key="JSON.stringify(item)"  as='li'>{{ item.text }}</TsTypography>
    </TsTypography>
  </TsCard>
</template>

<script setup lang="ts">
const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const { isMobile } = useDevice();

type List = {
  id: number;
  text: string;
}

type Props = {
  image?: string,
  alt?: string,
  title?:string,
  list?: List[],
  mobileText?: string,
  dataTestid: string,
}

const props = withDefaults(defineProps<Props>(), {
  mobileText:'Cannot use an item before return, need to be returned in the original packaging.',
  image:'/images/return(1).png',
  title:'Prepare For Return',
  list: () => [{id: 1, text: 'Ensure the item is in its original packaging with all accessories and manuals.'},
  {id: 2, text: 'Bring your proof of purchase (receipt or order confirmation email) with you to the store.'}
  ]
})

</script>